// The S/R store row from GET /v2/support-resistance (DWLF-333 key levels) as the
// chart's guide levels. Separate from marketsSlice so it can be tested without
// the slice's browser-only imports.
const earliestSourceTime = (level) => {
  const times = (level?.sources || [])
    .map((source) => Date.parse(source?.date))
    .filter(Number.isFinite);
  return times.length ? Math.min(...times) : undefined;
};

export const toChartKeyLevels = (row) => {
  const side = (levels) => (Array.isArray(levels) ? levels : [])
    .filter((level) => level?.level !== null && level?.level !== undefined && Number.isFinite(Number(level.level)))
    .map((level) => ({ ...level, formationTime: earliestSourceTime(level) }));
  return { support: side(row?.support), resistance: side(row?.resistance) };
};

// Stored key level events fetched for the whole lookback, kept only from the
// first loaded candle on: an earlier one would anchor to the first bar.
export const keyLevelEventsInRange = (events, candles) => {
  if (!Array.isArray(events) || !Array.isArray(candles) || candles.length === 0) {return [];}
  const firstT = Number(candles[0]?.t);
  return events.filter((event) => Number(event?.t) >= firstT);
};
